import React from 'react';
import '../App.css';
export class Footerapp extends React.Component {
    render() {
        return (
            <div className='sshfooterapp'>
            

            
            </div>
        );
    }
}